module.exports = __webpack_public_path__ + "static/media/arnav_singhal.4fe7cf4b.png";